import React from 'react'
import { Grid } from '@material-ui/core'

/**
 * Displays an icon and text side by side.
 * @param {Object} props
 * @param {JSX.Element} props.icon
 * @param {JSX.Element} props.text
 * @param {string} [props.margin] - Spacing in pixels between the icon and text.
 * @param {string} [props.className] - A custom class name that will be added to the container.
 * @param {boolean} [props.reverse] - If true, the icon will be displayed on the right side of the text.
 * @param {Function} [props.onClick] - Function to call when the component is clicked.
 */
const IconAndText = ({ icon, text, margin = '3px', reverse = false, className = '', onClick = () => {} }) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent={reverse ? 'flex-end' : 'flex-start'}
      direction={reverse ? 'row-reverse' : 'row'}
      className={className}
      onClick={onClick}
    >
      <Grid item style={{ lineHeight: 0.8, marginRight: reverse ? 0 : margin, marginLeft: reverse ? margin : 0 }}>
        {icon}
      </Grid>
      {text ? <Grid item>{text}</Grid> : null}
    </Grid>
  )
}

export default IconAndText
